import { array, boolean, number, object, string } from 'yup';

export const CounterTradeValidationSchema = object({
  active: boolean().required('Field is required'),
  // Maximum counter trade size in token (quote for buy, base for sell)
  max_counter_size: string()
    .required('Field is required')
    .test(
      'is-decimal',
      'Must be a valid decimal number',
      value => !isNaN(Number(value)) && Number(value) > 0,
    ),
  side: string().required('Field is required').oneOf(['buy', 'sell'], 'Must be either buy or sell'),
  // Slippage percentage (0-100)
  slippage: string()
    .required('Field is required')
    .test(
      'is-decimal',
      'Must be a valid decimal number',
      value => !isNaN(Number(value)) && Number(value) >= 0,
    )
    .test('is-percentage', 'Must be between 0 and 100', value => {
      const num = Number(value);
      return num >= 0 && num <= 100;
    }),
  // Counter trade size as percentage of target trade (compensation percentage)
  percentage: object({
    min: string()
      .required('Field is required')
      .test(
        'is-decimal',
        'Must be a valid decimal number',
        value => !isNaN(Number(value)) && Number(value) >= 0,
      ),
    max: string()
      .required('Field is required')
      .test(
        'is-decimal',
        'Must be a valid decimal number',
        value => !isNaN(Number(value)) && Number(value) >= 0,
      )
      .test('min-max', 'Max must be greater than min', function (value) {
        const min = Number(this.parent.min);
        const max = Number(value);
        return max > min;
      }),
  }).required('Field is required'),
  // Price range for bot reaction (price = quote/base, not in USD)
  price: object({
    min: string()
      .test(
        'is-decimal',
        'Must be a valid decimal number',
        value =>
          value === '' || value === undefined || (!isNaN(Number(value)) && Number(value) >= 0),
      )
      .test('max-required', 'Max must be specified when min is specified', function (value) {
        // If min is filled, max must also be filled
        if (value && value !== '' && (!this.parent.max || this.parent.max === '')) {
          return false;
        }
        return true;
      }),
    max: string()
      .test(
        'is-decimal',
        'Must be a valid decimal number',
        value =>
          value === '' || value === undefined || (!isNaN(Number(value)) && Number(value) >= 0),
      )
      .test('min-max', 'Max must be greater than min', function (value) {
        // If either field is empty, skip this validation
        if (!value || value === '' || !this.parent.min || this.parent.min === '') return true;

        const min = Number(this.parent.min);
        const max = Number(value);

        // If both are 0, it's valid (means no price restrictions)
        if (min === 0 && max === 0) return true;

        // Otherwise, max must be greater than min
        return max > min;
      }),
  }).required('Field is required'),
  // Target trade size range in quote token
  trigger_size: object({
    min: string()
      .required('Field is required')
      .test(
        'is-decimal',
        'Must be a valid decimal number',
        value => !isNaN(Number(value)) && Number(value) >= 0,
      ),
    max: string()
      .required('Field is required')
      .test(
        'is-decimal',
        'Must be a valid decimal number',
        value => !isNaN(Number(value)) && Number(value) >= 0,
      )
      .test('min-max', 'Max must be greater than min', function (value) {
        const min = Number(this.parent.min);
        const max = Number(value);
        return max > min;
      }),
  }).required('Field is required'),
  wallet_ids: array()
    .of(number().positive('Invalid wallet ID'))
    .min(1, 'At least one wallet must be selected')
    .required('Field is required'),
});
